import React from 'react';
import { View, StyleSheet } from 'react-native';
import R from '../../core-res/R';
import DRNImage from '../../standard/Image/DRNImage';
/* eslint-disable */
import LinearGradient from 'react-native-linear-gradient';
/* eslint-enable */
const uiDarkPrimaryNoOpacity = R.color.uiDarkPrimary + '00';
const Styles = StyleSheet.create({
    imageWrapper: {
        overflow: 'hidden',
        borderTopLeftRadius: R.border.radius.default,
        borderTopRightRadius: R.border.radius.default,
    },
    imageStyle: {
        minHeight: 180,
    },
});
function ImageRenderer(image, width) {
    return (<View style={Styles.imageWrapper}>
      <DRNImage source={{ uri: image }} style={[Styles.imageStyle, { width }]}/>
      <LinearGradient colors={[R.opacity.translucent(R.color.uiDarkPrimary), uiDarkPrimaryNoOpacity]} style={[Styles.gradientWrapper, { width, height: R.spacing.xxxxl, position: 'absolute', top: 0, left: 0 }]}/>
    </View>);
}
export default ImageRenderer;
